import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Mercari'
        title="Mercari Seller's Guide: The 3 Fastest Selling Categories"
      >
        <p>
          Using the well-known online clothes destination Mercari has many advantages for both the seller and buyer. Its
          simplicity and clean and modern interface, whether used in an Apple iPhone or Android, make it a user-friendly
          platform. Its shipping protection or insurance fee also makes it an appealing website or app to use. But while
          you may think the minimal effort is required, there are guaranteed ways for you to sell faster.
        </p>

        <p>
          Before, if you were able to sell five vintage pieces in two days, with this brief guide and a little more
          creativeness on your part, you may be able to sell more in such a short time. If you want to increase your
          sales, consider acquiring these items from different sources like a thrift store, a yard sale, or even from a
          department store when they are in the sale.
        </p>

        <h3>Trendy or Designer Clothing</h3>
        <p>
          Popular brands will always be on top of a person’s shopping list. Most often, people are on the lookout for
          luxury names such as Louis Vuitton, Gucci, Balenciaga, Rae Dunn, and even Nike to name a few. These brands are
          known for their top-notch quality that lasts a long time—and who wouldn’t want to own such esteemed pieces?
        </p>

        <p>
          When you list items on Mercari, always remember that the product name matters. People do check if you have the
          brand, especially if it’s a high-end one, they are looking for. So, having your items properly labeled allows
          you to easily come up in search results and directs people to you.
        </p>

        <p>
          Beyond the name, include pertinent information about the item you are selling: the style, the fabric, the size
          (you might want to include measurements), the condition (if there are flaws or defects). This is most crucial
          for dainty pieces like jewelry and accessories. In this way, buyers will already have an idea of what they are
          about to purchase.
        </p>

        <p>
          Now, where do you source these designers? You can check out your trusted thrift shop, visit a yard sale, or
          even scour other online destinations. From eBay to Poshmark to the Facebook Marketplace, you are sure to find
          branded clothing that is still presentable and wearable.
        </p>

        <p>
          However, take note that you have to be cautious in buying online. You want to avoid scammers or those who sell
          fake branded items. To do this, you can arrange and schedule meetups with the items you want to check for
          authenticity first before paying upfront. In this way, you don't have to pay additional online fees.
        </p>

        <p>
          As oftentimes, you will be meeting with strangers, make sure you ask for their ID first and are doing the
          transaction in public which is the perfect place where other people can see you both.
        </p>

        <h3>Women’s Sporting and Athletic Wear </h3>
        <p>
          Women oftentimes combine fashion and comfort when they work out—whether in the gym or jogging and running
          outside. Research shows there is a direct correlation between what one wears and how one performs. Clothes{' '}
          <a href='https://brainfodder.org/psychology-clothes-enclothed-cognition/'>do affect our mood</a>, including
          how we feel about ourselves. So, it matters that even when working out, one's athletic wear can still make one
          feel good.
        </p>

        <p>
          Among the many brands in the market, Athleta and Lululemon are in demand. Both are activewear companies known
          for their products for women—clothes for yoga, running, working out, and other sports.
        </p>

        <p>
          Why do these two stand out? Because they produce quality products. Athleta extended sizing to its 350 styles,
          which many buyers, not only in Mercari, will be able to relate to. Athleta had been partnering with famous
          athletes as well, such as the likes of Simone Biles and Allyson Felix.{' '}
        </p>

        <p>
          Lululemon Athletica also is a leading brand that creates performance fabrics fit for every activity. What is
          good about them is they have a free shipping fee and so you need not worry about additional costs.
        </p>

        <p>
          Take note, however, buying pre-loved or second-hand sports and athletic wear is tricky. So, sellers must be
          meticulous about indicating the size. Different brands vary from size to size, as such it would help to
          indicate actual measurements. If you really want to boost your sales, indicate the brand name upfront to
          capture attention and retain interest.
        </p>

        <p>
          If you are uncertain about how to list athletic wear, you can check out similar listings or similar items.
          These will give you an idea of which aspects to take note of and what else you can emphasize in your items.
        </p>

        <h3>Men’s Sneakers</h3>
        <p>
          There is a common perception that men are unlikely to buy pre-loved items, especially shoes. After all,
          quality matters the most to them. However, some may be surprised to see great finds in online marketplaces
          like Mercari and Depop with a lower price. Even millennials are certain to search for pre-loved shoes to save
          up or to sell for their side hustle.
        </p>

        <p>
          Top shoe brands Nike, Adidas, and New Balance have hundreds of different collections released throughout the
          years. While some are outdated, men would still search for certain styles as some treat shoes as their
          collection. Big Boy Cheng, for instance, has a{' '}
          <a href='https://www.youtube.com/watch?v=oixOJse19bk'>tremendous sneaker collection</a> that some would want
          to have as well.
        </p>

        <p>
          As men are particular about the condition of secondhand shoes, always check for the state of the heels or
          soles. You should only sell pairs that have a lightweight fit or are easy to wear around. When sourcing them
          first online, scroll past listings that don't show the entire condition of the shoes. After all, the soles
          make or break the comfort of the wearer—and this matters the most.
        </p>

        <p>
          Once you are satisfied with the overall condition of the shoes, purchase them and prepare to take photos for
          your listings. To do this, wash them up or clean them if the previous owner hasn't. Remember, presentation is
          crucial.
        </p>

        <p>
          If this is a pair of white sneakers, it matters all the more that they are in an almost pristine state. Be
          careful though that you don't scrub up dirt or grime too hard or use harsh chemicals that will change the
          color of the sneakers. There are a <a href='https://www.youtube.com/watch?v=plijXdDS-g4'>couple of tricks</a>{' '}
          you can do to achieve a "new look" for the sneakers or other pairs of shoes.
        </p>

        <p>
          When the pertinent details like brand, style, and size are complete in your listing, you may want to add
          suggestions on how to dress up with the particular pair you sell. In this way, potential buyers would
          immediately envision which clothes they have would be perfect for the sneakers you sell. The recommendation
          would surely entice them to message you, inquire more, and hopefully, make a purchase.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
